//#region Imports
import React, { useEffect, useLayoutEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
//MUI
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import { Backdrop, Box, Button, CircularProgress, Grid, MenuItem, Select, Typography, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import warning from '../../../images/warning.png';
import { tableStyleOverDue } from '../../../style/common';
import DoneIcon from '@mui/icons-material/Done';

//components
//scss
// import "./DueDateExtensionTable.scss"
import "../../../style/common.scss";
//Yup
import * as Yup from "yup";
//formik

import { useFormik } from 'formik';
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
import useScanDetection from 'use-scan-detection';
import CheckPermissions from '../../../authorization/authorization';
//Services
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import ProcessingSummaryTable from '../../../components/processingSummaryTable/processingSummaryTable';
import { tableStyle } from '../../../style/common';

import { useDispatch, useSelector } from 'react-redux';
import BasicTable from '../../../components/basicTable/basicTable';
import Error from '../../../components/error/error';
import { SearchIndividualApplication } from '../../../network/APIs/APIs';
import { addBusinessDays, calculateRemainingBusinessDays, dBillAPI, daysBetweenDatesExcludingWeekendsAndHolidays, downloadBill, numberFormatting, subdivisionName } from '../../../services/Functions';

import {
    fetchPaginatedDueDateExtensionNormal,
    filterDateFrom as filterDateFromNormal,
    filterDateTo as filterDateToNormal,
    filterObjectionStatus as filterObjectionStatusNormal,
    filterProgressId as filterProgressIdNormal,
    firstPage as firstPageNormal,
    lastPage as lastPageNormal,
    nextPage as nextPageNormal,
    previousPage as previousPageNormal,
    resetDateFilter as resetDateFilterNormal,
    resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
    resetProgressIdFilter as resetProgressIdFilterNormal
} from '../../../features/billingAndCollection/dueDateExtensionNormalSlice';

import {
    fetchPaginatedDueDateExtensionOverdue,
    filterDateFrom as filterDateFromOverdue,
    filterDateTo as filterDateToOverdue,
    filterObjectionStatus as filterObjectionStatusOverdue,
    filterProgressId as filterProgressIdOverdue,
    firstPage as firstPageOverdue,
    lastPage as lastPageOverdue,
    nextPage as nextPageOverdue,
    previousPage as previousPageOverdue,
    resetDateFilter as resetDateFilterOverdue,
    resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
    resetProgressIdFilter as resetProgressIdFilterOverdue
} from '../../../features/billingAndCollection/dueDateExtensionOverdueSlice';
//#endregion

const DueDateExtensionTable = forwardRef((props, ref) => {

    //#region initial values
    const initialValues = {
        iv_approved_no_of_days: null,
        iv_approved_due_date: null
    }
    //#endregion

    //#region get item local storage 
    const { token, code: officeCode, hierarchy: officeHierarchy, userId, permissions } = useSelector((state) => state.auth);
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    //#endregion

    //#region states

    const [error, setError] = useState()
    const [ddeApplicationsNormal, setDdeApplicationsNormal] = useState([]);
    const [ddeApplicationsNormalToDataGrid, setDdeApplicationsNormalToDataGrid] = useState([]);
    const [dayName, setDayName] = useState('-');
    const [ddeApplicationsOverdue, setDdeApplicationsOverdue] = useState([]);
    const [ddeApplicationsOverdueToDataGrid, setDdeApplicationsOverdueToDataGrid] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [applicationId, setapllicationid] = React.useState('')
    const [eFileData, setEFileData] = useState([]);
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [applicationSubittedPopUp, setApplicationSubmittedPopUp] = useState(false);
    const [availableDays, setAvailableDays] = useState([]);
    const [approvedPopup, setApprovedPopup] = useState(false)
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const tableColumnsProcessingSummary = [
        {
            header: 'Step',
            accessorKey: 'stepName',
        },
        {
            header: 'Processed By',
            accessorKey: 'processedBy',
        },
        {
            header: 'Date',
            accessorKey: 'date',
        },
        {
            header: 'Remarks',
            accessorKey: 'remarks',
        },
    ]

    const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
    ])
    const dispatch = useDispatch();
    let DDStatusBarArray = [
        {
            title1: 'APPLICATION',
            title2: 'SUBMITTED',
        },
        {
            title1: 'ACTION',
            title2: 'TAKEN',
        },

    ]

    const [foundInDDE, setFoundInDDE] = useState();
    const { state } = useLocation();
    const { foundId } = state ? state : '';
    const [isReleventToUser, setIsRelevantToUser] = useState(false)


    //#endregion

    //#endregion

    const { currentPage: currentPageNormal, data: dataNormal, pageSize: pageSizeNormal, totalPages: totalPagesNormal, totalRecords: totalRecordsNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, error: errorNormal, isLoading: isLoad } = useSelector((state) => state.dueDateExtensionNormalPaginated);
    const { currentPage: currentPageOverdue, data: dataOverdue, pageSize: pageSizeOverdue, totalPages: totalPagesOverdue, totalRecords: totalRecordsOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, error: errorOverdue, isLoading: isLoadd } = useSelector((state) => state.dueDateExtensionOverduePaginated);

    const handleNextPage = () => {
        setViewBackdrop(true)
        dispatch(nextPageNormal());
    };

    const handleDateFromFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromNormal(value))
        }
    }

    const handleDateToFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToNormal(value))
        }
    }

    const handleResetDateFilter = () => {
        dispatch(resetDateFilterNormal())
    }

    const handleProgressIdFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdNormal(value))
        }
    }

    const handleResetProgressIdFilter = () => {
        dispatch(resetProgressIdFilterNormal())
    }

    const handleObjectionStatusFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusNormal(value))
        }
    }

    const handleResetObjectionStatusFilter = () => {
        dispatch(resetObjectionStatusFilterNormal())
    }

    const handlePreviousPage = () => {
        setViewBackdrop(true)
        dispatch(previousPageNormal());
    };

    const handleFirstPage = () => {
        dispatch(firstPageNormal());
    };

    const handleLastPage = () => {
        dispatch(lastPageNormal(totalPagesNormal)); // Replace '2' with actual value
    };

    useEffect(() => {
        if ((props.showTable && currentPath == "/due-date-extension-table") && token) {
            setViewBackdrop(true)
            dispatch(fetchPaginatedDueDateExtensionNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
        }
    }, [currentPageNormal, pageSizeNormal, dateFromNormal, dateToNormal, applicationProgressIdNormal, objectionStatusNormal]);

    // useEffect(() => {
    //     if ((props.showTable && currentPath == "/due-date-extension-table")) {
    //         setViewBackdrop(true)
    //         dispatch(fetchPaginatedDueDateExtensionNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
    //     }
    // }, []);

    useEffect(() => {
        if (dataNormal) {
            setDdeApplicationsNormal(dataNormal)
            setViewBackdrop(false)
        }
    }, [dataNormal])

    const handleNextPageOverdue = () => {
        setViewBackdrop(true)
        dispatch(nextPageOverdue());
    };

    const handleDateFromFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromOverdue(value))
        }
    }

    const handleDateToFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToOverdue(value))
        }
    }

    const handleResetDateFilterOverdue = () => {
        dispatch(resetDateFilterOverdue())
    }

    const handleProgressIdFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdOverdue(value))
        }
    }

    const handleResetProgressIdFilterOverdue = () => {
        dispatch(resetProgressIdFilterOverdue())
    }

    const handleObjectionStatusFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusOverdue(value))
        }
    }

    const handleResetObjectionStatusFilterOverdue = () => {
        dispatch(resetObjectionStatusFilterOverdue())
    }

    const handlePreviousPageOverdue = () => {
        setViewBackdrop(true)
        dispatch(previousPageOverdue());
    };

    const handleFirstPageOverdue = () => {
        dispatch(firstPageOverdue());
    };

    const handleLastPageOverdue = () => {
        dispatch(lastPageOverdue(totalPagesOverdue)); // Replace '2' with actual value
    };

    useEffect(() => {
        if ((props.showTable && currentPath == "/due-date-extension-table")) {
            if (token) {
                setViewBackdrop(true)
                dispatch(fetchPaginatedDueDateExtensionOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue }));
            }
        }
    }, [currentPageOverdue, pageSizeOverdue, dateFromOverdue, dateToOverdue, applicationProgressIdOverdue, objectionStatusOverdue]);

    // useEffect(() => {
    //     if ((props.showTable && currentPath == "/due-date-extension-table")) {
    //         setViewBackdrop(true)
    //         dispatch(fetchPaginatedDueDateExtensionOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue }));
    //     }
    // }, []);

    useEffect(() => {
        if (dataOverdue) {
            setDdeApplicationsOverdue(dataOverdue)
            setViewBackdrop(false)
        }
    }, [dataOverdue])

    //#region api function
    const duedateextensionapi = async (x, values) => {
        setViewBackdrop(true)
        const formattedDate = values.split("-").reverse().join("-");
        console.log(formattedDate, values, 'formattedDate')
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        formdata.append("lastModifiedBy", userId);
        formdata.append("applicationProgressId", x);
        formdata.append("approvedExtendedDueDate", formattedDate);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;
        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };
        await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    setViewBackdrop(false)
                    handleClose()
                    window.location.reload();
                } else if (result.message.startsWith('Since the month end process')) {
                    setError(result.message)
                    setViewBackdrop(false)
                } else if (result.status === '400') {
                    setError(result.message)
                    setViewBackdrop(false)
                }
            })
            .catch(error => console.log('error', error));
    }

    const objectionpop = async () => {
        await duedateextensionapi(-1, dueDateApprovalFormik.values.iv_approved_due_date)
    }

    const callEfileAPI = async (application) => {
        var formdata = new FormData();
        formdata.append("applicationId", application.applicationId);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "dateExtention/getDueDateExtentionHistory", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    let applicationCurrentState = result.applicationCurrentState[0]
                    let applicationHistory = result.applicationHistory
                    if (applicationHistory === "No History Found") {
                        applicationHistory = []
                    }

                    applicationHistory.push(applicationCurrentState)
                    let sortedApplicationHistory = applicationHistory.sort((a, b) => {
                        const dateA = new Date(a.lastModificationDate)
                        const dateB = new Date(b.lastModificationDate)
                        return dateB - dateA
                    });

                    setEFileData(sortedApplicationHistory)

                    let dataforTable = []

                    sortedApplicationHistory.forEach(item => {
                        if (item.applicationProgressId !== 0 && item.lastModifiedBy && item.lastModificationDate) {
                            let object = {}
                            object.stepName = stepName(item.applicationProgressId)
                            object.processedBy = item.lastModifiedBy ? item.lastModifiedBy : 'Last Modified By Name'
                            object.date = item.lastModificationDate ? convertDatewithTime(item.lastModificationDate) : 'Last Modification Time'
                            object.remarks = item.remarks ? item.remarks : '-'
                            dataforTable.push(object)
                        }
                    })

                    dataforTable.push({
                        date: convertDate(application.creationDate),
                        processedBy: application.name,
                        stepName: "Application Submitted",
                        time: convertDatewithTime(application.creationDate).slice(11, 17),
                        remarks: '-'
                    })

                    setTableDataProcessingSummary(dataforTable);
                }
                else {
                }
            })
            .catch(error => console.log('error', error));
    }
    //#endregion

    //#region functions

    const errorCloses = () => {
        setError('')
    }

    useScanDetection({
        onComplete: async (code) => {
            if (code) {
                code = code.replace(/Shift/g, '');
                const regex = /^[A-Z]{2}-\d{14,15}$/;
                if (regex.test(code)) {
                    await handleRowClick(code);
                } else {
                    console.warn('Invalid code format:', code);
                }
            }
        },
        minLength: 4, // EAN13
    });

    const handleClose = async () => {
        setIsRelevantToUser(false)
        dueDateApprovalFormik.resetForm();
        dueDateApprovalFormik.values.iv_approved_no_of_days = null;
        dueDateApprovalFormik.values.iv_approved_due_date = null;
        setFoundInDDE();
        setOpen(false);
        dispatch(fetchPaginatedDueDateExtensionNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
        dispatch(fetchPaginatedDueDateExtensionOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue }));
        window.location.reload();
    };

    const getClassName = (x) => {
        if (x === "Pending") {
            return 'pending-button';
        }
        else if (x === "In Process") {
            return 'inprocess-button';
        }
        else if (x === "Approved") {
            return 'approved-button';
        }
        else if (x === "Objection") {
            return 'objection-button';
        }
        else if (x === "Rejected") {
            return 'rejected-button';
        }
    }

    const filterNCApp = async (applicationId) => {
        let myArray = ddeApplicationsNormal
        let totalArray = myArray.concat(ddeApplicationsOverdue)
        let itemFound = totalArray.find(item => item.applicationId === applicationId)
        console.log(itemFound, 'item found')
        // if (itemFound === undefined) {
        //     itemFound = await SearchIndividualApplication(token, applicationId, '7')
        //     setIsRelevantToUser(itemFound.isReleventToUser)
        // }

        if (itemFound) {
            setIsRelevantToUser(true)
        }
        else if (itemFound === undefined) {
            itemFound = await SearchIndividualApplication(token, applicationId, '7')
            console.log(itemFound, 'itemFound')
            setIsRelevantToUser(itemFound.isReleventToUser)
        }
        return itemFound;
    }

    const convertDate = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const convertDatewithTime = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    }

    const apiToDataGridConversionNormal = () => {

        const tempArray = []
        if (ddeApplicationsNormal) {
            ddeApplicationsNormal.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.refNo,
                            "name": item.name,
                            "dueDate": convertDate(item.dueDate),
                            "extendedDueDate": convertDate(item.appliedExtentionOfDueDate),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.refNo,
                            "name": item.name,
                            "dueDate": item.dueDate,
                            "extendedDueDate": item.appliedExtentionOfDueDate,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.remarks,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "connectionType": '',
                // "appliedLoad": item.appliedLoad,
                // "duration": item.duration,
                "applicantName": ' ',
                "applicantCNIC": ' ',
                "applicationStatusId": statusFunc(' '),
            }
            tempArray.push(dataGridObject)
        }
        setDdeApplicationsNormalToDataGrid(tempArray);
    }

    const apiToDataGridConversionOverdue = () => {

        const tempArray = []
        if (ddeApplicationsOverdue) {
            ddeApplicationsOverdue.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.refNo,
                            "name": item.name,
                            "dueDate": convertDate(item.dueDate),
                            "extendedDueDate": convertDate(item.appliedExtentionOfDueDate),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.refNo,
                            "name": item.name,
                            "dueDate": item.dueDate,
                            "extendedDueDate": item.appliedExtentionOfDueDate,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.remarks,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "connectionType": '',
                // "appliedLoad": item.appliedLoad,
                // "duration": item.duration,
                "applicantName": ' ',
                "applicantCNIC": ' ',
                "applicationStatusId": statusFunc(' '),
            }
            tempArray.push(dataGridObject)
        }
        setDdeApplicationsOverdueToDataGrid(tempArray);
    }

    const statusFunc = (x, objection) => {
        if (x === 0) {
            return 'In Process'
        }
        else if (x === 1) {
            return 'Approved'
        }
        else if (x === -1) {
            return 'Rejected'
        }
    }

    const progFunc = (x) => {
        if (x === 0) {
            return 'Documents Uploading'
        }
        else if (x === 1) {
            return 'Documents Verification'
        }
        else if (x === 2) {
            return 'Arrears Verification'
        }
        else if (x === 3) {
            return 'Field Verification'
        }
        else if (x === 4) {
            return 'Demand Note Issued'
        }
        else if (x === 5) {
            return 'DN Payment Verification'
        }
        else if (x === 6) {
            return 'Meter Installation'
        }
        else if (x === 7) {
            return 'Ready for Billing'
        }
    }
    const formatToDDMMYYYY = (dateString) => {
        if (!dateString) return "-";

        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    };
    const handleRowClick = async (applicationId, event) => {
        const item = await filterNCApp(applicationId);
        if (item) {
            setDialogRowData(item);
            console.log(item, "itemsdksdas")
            let noOfDaysApplied = daysBetweenDatesExcludingWeekendsAndHolidays(new Date(item.dueDate), new Date(item.appliedExtentionOfDueDate));
            const remainingDays = calculateRemainingBusinessDays(item.dueDate);
            setAvailableDays(remainingDays);
            dueDateApprovalFormik.values.iv_approved_no_of_days = noOfDaysApplied
            dueDateApprovalFormik.values.iv_approved_due_date = formatToDDMMYYYY(item.appliedExtentionOfDueDate)

            let dataforTable = [];

            if (item.applicationProgressId === 0) {
                dataforTable.push({
                    date: convertDate(item.creationDate),
                    processedBy: item.name,
                    stepName: "Application Submitted",
                    time: convertDatewithTime(item.creationDate).slice(11, 17),
                    remarks: 'Application Submitted.'
                });
            }
            else if (item.applicationProgressId === 1 || item.applicationProgressId === -1) {

                dataforTable.push({
                    stepName: stepName(item.applicationProgressId),
                    processedBy: item.lastModifiedBy || 'N/A',
                    date: item.lastModificationDate ? convertDatewithTime(item.lastModificationDate) : 'N/A',
                    remarks: item.remarks || '-',
                });

                dataforTable.push({
                    date: convertDate(item.creationDate),
                    processedBy: item.name,
                    stepName: "Application Submitted",
                    time: convertDatewithTime(item.creationDate).slice(11, 17),
                    remarks: 'Application Submitted.'
                });

            }

            setTableDataProcessingSummary(dataforTable);


            // await callEfileAPI(item);
            setapllicationid(item.applicationId)
            setOpen(true);
        }
    };

    const openDetailsPopUp = async (stepName) => {
        let id = dialogRowData.applicationId

        if (stepName === "APPLICATION SUBMITTED" || stepName === "Application Submitted") {
            setApplicationSubmittedPopUp(true)
        }
    }

    const stepName = (x) => {
        if (x === 0) {
            return 'Application Submission'
        }
        else if (x === 1 || x === -1) {
            return 'Action Taken'
        }
    };

    //#endregion

    //#region formiks

    const dueDateApprovalFormik = useFormik({
        initialValues,
        validationSchema: Yup.object({
            // iv_approved_no_of_days: Yup.number().required('Enter number of days to extend due date.'),
            iv_approved_due_date: Yup.string().required('Extended due date is required.')
        }),
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true)
            try {

                const x = 1;

                const formattedDate = values.iv_approved_due_date.split("-").reverse().join("-");
                console.log(formattedDate, values, 'formattedDate')

                var formdata = new FormData();
                // formdata.append("remarks", "Approved.");
                formdata.append("applicationId", applicationId);
                formdata.append("lastModifiedBy", userId);
                formdata.append("applicationProgressId", x);
                formdata.append("approvedExtendedDueDate", formattedDate);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);;
                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };
                await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === '200') {
                            setApprovedPopup(true)
                        } else {
                            setError(result.message)
                        }
                    })
                    .catch(error => console.log('error', error));
            }
            catch (e) {
                console.log(e)
            }
            setViewBackdrop(false)
        }
    })

    //#endregion

    //#region useEffects

    useEffect(() => {
        if (ddeApplicationsNormal) {
            apiToDataGridConversionNormal()
        }
    }, [ddeApplicationsNormal]);

    useEffect(() => {
        if (ddeApplicationsOverdue) {
            apiToDataGridConversionOverdue()
        }
    }, [ddeApplicationsOverdue]);

    useEffect(() => {
        if (foundId && foundId !== '') {
            setFoundInDDE(foundId)
        }
    }, [foundId])

    useLayoutEffect(() => {
        if (foundInDDE) {
            handleRowClick(foundInDDE)
        }
    }, [foundInDDE])

    useEffect(() => {
        if (dueDateApprovalFormik.values.iv_approved_no_of_days) {
            let appliedDueDate = new Date(dialogRowData.dueDate);
            let futureDate = addBusinessDays(appliedDueDate, dueDateApprovalFormik.values.iv_approved_no_of_days);
            const year = futureDate.getFullYear();
            const month = ('0' + (futureDate.getMonth() + 1)).slice(-2);
            const day = ('0' + futureDate.getDate()).slice(-2);
            const formattedDate = `${day}-${month}-${year}`;
            dueDateApprovalFormik.values.iv_approved_due_date = formattedDate;
        }
    }, [dueDateApprovalFormik.values.iv_approved_no_of_days])
    const getDayName = (dateString) => {
        if (!dateString) return "-";

        let date;

        if (dateString.includes("-") && dateString.split("-")[0].length === 4) {
            const [year, month, day] = dateString.split("-");
            date = new Date(Number(year), Number(month) - 1, Number(day));
        } else if (dateString.includes("-")) {
            const [day, monthStr, year] = dateString.split("-");
            const month = new Date(Date.parse(monthStr + " 1, 2020")).getMonth();
            date = new Date(Number(year), month, Number(day));
        } else {
            return "-";
        }

        if (isNaN(date)) return "-";
        return date.toLocaleString("en-US", { weekday: "long" });
    };
    const formatDateToShortMonth = (dateString) => {
        if (!dateString) return "-";

        const [day, month, year] = dateString.split("-");
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const monthIndex = parseInt(month, 10) - 1;
        if (monthIndex < 0 || monthIndex > 11) return "-";

        return `${day}-${months[monthIndex]}-${year}`;
    };


    //#endregion

    const tblColumns = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "dueDate", type: 'dateTime', headerName: 'Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "extendedDueDate", type: 'dateTime', headerName: 'Requested Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            field: "applicationStatusId",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: true,
            type: 'singleSelect',
            valueOptions: ['In Process', 'Approved', 'Rejected'],
            renderCell: (params) => {
                let btnText = (params.applicationStatusId)
                return (
                    <div style={{ display: 'flex' }}>
                        {
                            params.releventApplicationFlage ?
                                <div class="blinking-circle">
                                    <span className='hover-text'>
                                        Needs Action
                                    </span>
                                </div> :
                                <div className='empty-circle'></div>
                        }
                        <div className={getClassName(btnText)} >{btnText}</div>
                    </div>
                )
            }
        },
    ]

    const tblColumnsOverDue = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "name", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "dueDate", type: 'dateTime', headerName: 'Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "extendedDueDate", type: 'dateTime', headerName: 'Requested Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        {
            field: "applicationStatusId",
            headerStyle: tableStyleOverDue.headerStyle,
            headerCellStyle: tableStyleOverDue.headerCellStyle,
            rowCellStyle: tableStyleOverDue.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: true,
            type: 'singleSelect',
            valueOptions: ['In Process', 'Approved', 'Rejected'],
            renderCell: (params) => {
                let btnText = (params.applicationStatusId)
                return (
                    <div style={{ display: 'flex' }}>
                        {
                            params.releventApplicationFlage ?
                                <div class="blinking-circle">
                                    <span className='hover-text'>
                                        Needs Action
                                    </span>
                                </div> :
                                <div className='empty-circle'></div>
                        }
                        <div className={getClassName(btnText)} >{btnText}</div>
                    </div>
                )
            }
        },
    ]

    useImperativeHandle(ref, () => ({
        handleRowClick
    }));

    const location = useLocation()
    const currentPath = location.pathname;

    const ranges = [
        { max: 25000, perm: '1 - 25,000' },
        { max: 50000, perm: '25,001 - 50,000' },
        { max: 100000, perm: '50,001 - 100,000' },
        { max: 200000, perm: '100,001 - 200,000' },
        { max: 300000, perm: '200,001 - 300,000' },
        { max: 500000, perm: '300,001 - 500,000' },
        { max: 1000000, perm: '500,001 - 1,000,000' },
        { max: 20000000, perm: '1,000,001 - 20,000,000' },
        { max: Infinity, perm: '20,000,001 - MAX' },
    ];

    const canApprove = (billAmount) => {
        let maxLimit = 0;

        for (let i = 0; i < ranges.length; i++) {
            const { max, perm } = ranges[i];

            const hasPermission = CheckPermissions(
                permissions,
                'Billing and Collection',
                'Due Date Extension',
                'Workflow Permissions',
                perm
            );

            if (hasPermission) {
                maxLimit = max;
            } else {
                break;
            }
        }

        return billAmount <= maxLimit;
    };

    const formatMonthYear = (dateString) => {
        if (!dateString) return '-';
        const cleanDateString = dateString.split('T')[0];
        const date = new Date(cleanDateString);
        if (isNaN(date)) return '-';
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        return `${month}-${year}`;
    };

    const isExtensionDateExpired = (dateString) => {
        if (!dateString) return false;

        const appliedDate = new Date(dateString);
        const today = new Date();


        appliedDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return appliedDate < today;
    };

    const handleOpen = () => {
        setOpenCancelModal(true);
    };

    const handleCloseRemarks = () => {
        setOpenCancelModal(false);
        remarksFormik.resetForm({
            values: { iv_remarks: "" },
        });
    };

    const remarksFormik = useFormik({
        initialValues: {
            iv_remarks: "",
            // Add iv_approved_due_date if it’s part of the form
            // iv_approved_due_date: "",
        },
        validationSchema: Yup.object({
            iv_remarks: Yup.string()
                .min(10, "Remarks should be at least 10 characters.")
                .max(100, "Remarks should be less than 100 characters.")
                .required("Enter remarks."),
            // Add validation for iv_approved_due_date if needed
            // iv_approved_due_date: Yup.string().required("Date is required."),
        }),
        onSubmit: async (values) => {
            const x = -1;
            const formattedDate = dialogRowData.appliedExtentionOfDueDate
            console.log("x:", x, "userId:", userId, "applicationId:", applicationId, "Date", formattedDate, "values", values);
            setViewBackdrop(true);
            try {
                const formdata = new FormData();
                //   formdata.append("remarks", values.iv_remarks); 
                formdata.append("applicationId", applicationId);
                formdata.append("lastModifiedBy", userId);
                formdata.append("applicationProgressId", x);
                formdata.append("approvedExtendedDueDate", formattedDate);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                const requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };
                await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === '200') {
                            setOpenCancelModal(false);
                            handleClose();
                        } else if (result.message?.startsWith('Since the month end process')) {
                            setError(result.message);
                        } else {
                            setError('Failed to submit the application.');
                        }
                    })
                    .catch(error => console.log('error', error));
            } catch (e) {
                console.error("Submission error:", e);
            }
            setViewBackdrop(false);

        },
    });

    // const remarksFormik = useFormik({
    //     initialValues: {
    //         iv_remarks: "",
    //     },
    //     validationSchema: Yup.object({
    //         iv_remarks: Yup.string()
    //             .min(10, "Remarks should be at least 10 characters.")
    //             .max(100, "Remarks should be less than 100 characters.")
    //             .required("Enter remarks."),
    //     }),
    //     onSubmit: async (values) => {
    //         const x = -1
    //         const formattedDate = values.iv_approved_due_date.split("-").reverse().join("-");
    //             console.log(formattedDate, values,x,userId,applicationId, 'formattedDate')
    //         // setViewBackdrop(true)
    //         // try {
    //         //     const x = -1
    //         //     const formattedDate = values.split("-").reverse().join("-");
    //         //     console.log(formattedDate, values, 'formattedDate')
    //         //     var formdata = new FormData();
    //         //     formdata.append("applicationId", applicationId);
    //         //     formdata.append("lastModifiedBy", userId);
    //         //     formdata.append("applicationProgressId", x);
    //         //     formdata.append("approvedExtendedDueDate", formattedDate);
    //         //     const myHeaders = new Headers();
    //         //     myHeaders.append("Authorization", token);;
    //         //     var requestOptions = {
    //         //         method: 'POST',
    //         //         body: formdata,
    //         //         headers: myHeaders,
    //         //         redirect: 'follow',
    //         //     };
    //         //     await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
    //         //         .then(response => response.json())
    //         //         .then(result => {
    //         //             if (result.status === '200') {
    //         //                 setOpenCancelModal(false)
    //         //                 handleClose()
    //         //             } else if (result.message?.startsWith('Since the month end process')) {
    //         //                 setError(result.message);
    //         //             } else {
    //         //                 setError('Failed to submit the application.');
    //         //             }
    //         //         })
    //         //         .catch(error => console.log('error', error));
    //         // }
    //         // catch (e) {
    //         // }
    //         // setViewBackdrop(false)
    //     },
    // });
    return (
        console.log(dialogRowData.appliedExtentionOfDueDate, "dialogRowData.appliedExtentionOfDueDate"),
        <>
            {
                (props.showTable && currentPath == "/due-date-extension-table") &&
                <Box className='form-box'>
                    <div style={{ display: 'flex', flexDirection: "row" }}>
                        <Box className='application-table' style={{ marginRight: '10px' }}>
                            <h3 style={{ color: '#006ad1', marginBottom: '10px' }}>Due Date Extensions  ( {numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )</h3>
                            <div className='div-datagrid' >
                                <BasicTable
                                    columns={tblColumns}
                                    data={ddeApplicationsNormalToDataGrid}
                                    handleRowClick={(params) => handleRowClick(params.applicationId)}
                                    sx={tableStyle}
                                    rowHeight={37}
                                    pageSize={20}
                                    firstPage={handleFirstPage}
                                    lastPage={handleLastPage}
                                    totalPages={totalPagesNormal}
                                    totalRecords={totalRecordsNormal}
                                    currentPage={currentPageNormal}
                                    handleFilterDateFrom={handleDateFromFilter}
                                    handleFilterDateTo={handleDateToFilter}
                                    resetDateFilter={handleResetDateFilter}
                                    handleFilterProgressId={handleProgressIdFilter}
                                    handleFilterObjectionStatus={handleObjectionStatusFilter}
                                    resetProgressIdFilter={handleResetProgressIdFilter}
                                    resetObjectionStatusFilter={handleResetObjectionStatusFilter}
                                    nextPage={handleNextPage}
                                    previousPage={handlePreviousPage}
                                    isLoading={isLoad}
                                    rowsPerPageOptions={[18, 30, 60]}
                                    rowsPageOption={false}
                                    getRowStyle={(params) => {
                                        return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                                    }}
                                />
                            </div>
                        </Box>
                        <Box className='application-table' >
                            <div style={{ display: 'flex', alignItems: 'end' }}>
                                <h3 style={{ color: '#9d192f', marginBottom: '10px' }}><img src={warning} alt='icon' style={{ width: '1vw', marginRight: '5px' }} />Over Due Applications  ( {numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"} )</h3>
                            </div>
                            <div className='div-datagrid' >
                                <BasicTable
                                    columns={tblColumnsOverDue}
                                    data={ddeApplicationsOverdueToDataGrid}
                                    handleRowClick={(params) => handleRowClick(params.applicationId)}
                                    sx={tableStyleOverDue}
                                    rowHeight={37.5}
                                    pageSize={20}
                                    firstPage={handleFirstPageOverdue}
                                    nextPage={handleNextPageOverdue}
                                    previousPage={handlePreviousPageOverdue}
                                    lastPage={handleLastPageOverdue}
                                    handleFilterDateFrom={handleDateFromFilterOverdue}
                                    handleFilterDateTo={handleDateToFilterOverdue}
                                    resetDateFilter={handleResetDateFilterOverdue}
                                    resetProgressIdFilter={handleResetProgressIdFilterOverdue}
                                    resetObjectionStatusFilter={handleResetObjectionStatusFilterOverdue}
                                    handleFilterProgressId={handleProgressIdFilterOverdue}
                                    handleFilterObjectionStatus={handleObjectionStatusFilterOverdue}
                                    totalPages={totalPagesOverdue}
                                    totalRecords={totalRecordsOverdue}
                                    currentPage={currentPageOverdue}
                                    rowsPerPageOptions={[18, 30, 60]}
                                    isLoading={isLoadd}
                                    rowsPageOption={false}
                                    getRowStyle={(params) => {
                                        return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyleOverDue.evenRow : tableStyleOverDue.oddRow
                                    }}
                                />
                            </div>
                        </Box>
                    </div>
                </Box>
            }

            {/* Main Popup */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'false'}
                className='main-dialog'
            >
                <DialogTitle className="dialog-title" >
                    <Grid container spacing={1} className='headercontainer'>
                        <Grid item lg={0.5}></Grid>
                        <Grid item lg={11} className='applicationTitleGrid'>
                            <Typography className="applicationTitleText">Due Date Extension  -
                                <span style={{ color: 'white' }}>
                                    {dialogRowData.applicationProgressId === 0 && ` Application Received`}
                                    {dialogRowData.applicationProgressId === 1 && ' Action Taken'}
                                </span>
                            </Typography>
                        </Grid>
                        <Grid item lg={0.25}>
                        </Grid>
                        <Grid item lg={0.25} className="closeIcon" >
                            <CloseIcon id="clearPopup" onClick={handleClose} sx={{ color: 'white' }} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="dialog-content">
                        <Grid container spacing={1} className='headercontainer'>
                            <Grid item lg={12} className='status-bar'>
                                <StepProgressBar array={DDStatusBarArray} applicationProgressId={dialogRowData.applicationProgressId + 1} objection={dialogRowData.objectionStatus} openDetailsPopUp={openDetailsPopUp} pageName='Due Date Extension' />
                            </Grid>
                            <Grid item lg={12} className='application-details' >
                                {/* <p className='title'>Application Details</p> */}
                                <Grid container gap={'4%'} className="first-row">
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'> Application Id.</p>
                                        <p className='prop-detail'> {dialogRowData.applicationId}</p>
                                    </Grid>
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'> Reference No.</p>
                                        <p className='prop-detail'> {dialogRowData.refNo ? dialogRowData.refNo : "-"}</p>
                                    </Grid>
                                    <Grid item lg={3.5} className='first-row-item'>
                                        <p className='prop-title'> Address</p>
                                        <p className='prop-detail'> {dialogRowData.address ? dialogRowData.address : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1} className='first-row-item'>
                                        <p className='prop-title'> Connection Type </p>
                                        <p className='prop-detail'> {dialogRowData.connectionType ? dialogRowData.connectionType : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1} className='first-row-item'>
                                        <p className='prop-title'> Tariff </p>
                                        <p className='prop-detail'> {dialogRowData.tariffCode ? dialogRowData.tariffCode : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1} className='first-row-item'>
                                        <p className='prop-title'> Subdivision </p>
                                        <p className='prop-detail'> {subdivisionName(dialogRowData.subDivisionCode, subDivisions)}</p>
                                    </Grid>
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'>Applicant Name</p><p className='prop-detail'>{dialogRowData.name ? dialogRowData.name : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'>Applicant CNIC</p><p className='prop-detail'>{dialogRowData.cnic ? dialogRowData.cnic : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'>Applicant Phone</p><p className='prop-detail'>{dialogRowData.applicantPhone ? dialogRowData.applicantPhone : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1.5} className='first-row-item'>
                                        <p className='prop-title'>Applicant Email</p><p className='prop-detail'>{dialogRowData.applicantEmail ? dialogRowData.applicantEmail : "-"}</p>
                                    </Grid>
                                    <Grid item lg={1} className="first-row-item">
                                        <p className='prop-title'>Customer ID</p><p className='prop-detail'>{dialogRowData.customerId ? dialogRowData.customerId : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1} className='first-row-item'>
                                        <p className='prop-title'>Bill Month</p><p className='prop-detail'>{dialogRowData.billMonth ? formatMonthYear(dialogRowData.billMonth) : '-'}</p>
                                    </Grid>
                                    <Grid item lg={1} className="first-row-item">
                                        <p className='prop-title'>Bill Amount</p><p className='prop-detail'>{dialogRowData.currentBillAmount ? dialogRowData.currentBillAmount : '-'}</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item className='processing-summary'>
                                <p className='title'>Activity Log</p>
                                {
                                    <ProcessingSummaryTable data={tableDataProcessingSummary} columns={tableColumnsProcessingSummary} openDetailsPopUp={openDetailsPopUp} />
                                }
                            </Grid>
                            <Grid item className="action-form">
                                <div className='fields'>
                                    {
                                        dialogRowData.applicationProgressId === 0 ?

                                            <>
                                                <h3 className='step-title'>Application Received from {dialogRowData.cfcName ? dialogRowData.cfcName : dialogRowData.submittedThrough ? dialogRowData.submittedThrough : " "}</h3>
                                                <Grid container className='field-survey-container'>
                                                    {
                                                        error &&
                                                        <Error
                                                            error={error}
                                                            onClose={() => errorCloses()}
                                                            backgroundColor="#FFC0CB"
                                                            textColor="#bb0303"
                                                            iconColor="#bb0303"
                                                        />
                                                    }
                                                    <Grid container spacing={2} sx={{ mt: 2 }}>

                                                        {/* Customer ID */}
                                                        <Grid item lg={6} md={4} sm={6} xs={12}>
                                                            <Typography className='label'>
                                                                Current Due Date
                                                            </Typography>
                                                            <TextField
                                                                value={dialogRowData.dueDate ? convertDate(dialogRowData.dueDate) : '-'}
                                                                fullWidth
                                                                size="small"
                                                                variant="outlined"
                                                                disabled
                                                                InputProps={{
                                                                    style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                }}
                                                            />
                                                        </Grid>

                                                        {/* Bill Month */}
                                                        <Grid item lg={6} md={4} sm={6} xs={12}>
                                                            <Typography className='label'>
                                                                Requested Due Date
                                                            </Typography>
                                                            <TextField
                                                                value={dialogRowData.appliedExtentionOfDueDate ? convertDate(dialogRowData.appliedExtentionOfDueDate) : '-'}
                                                                fullWidth
                                                                size="small"
                                                                variant="outlined"
                                                                disabled
                                                                InputProps={{
                                                                    style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                }}
                                                            />
                                                        </Grid>

                                                        {/* No. of Days to Extend */}
                                                        <Grid item lg={6} md={4} sm={6} xs={12}>
                                                            <Typography className='label'>
                                                                No. of Days to Extend
                                                            </Typography>
                                                            <Select
                                                                value={dueDateApprovalFormik.values.iv_approved_no_of_days}
                                                                onChange={dueDateApprovalFormik.handleChange}
                                                                name="iv_approved_no_of_days"
                                                                displayEmpty
                                                                className="fieldBatch"
                                                                fullWidth
                                                                size="small"
                                                            >
                                                                <MenuItem value="" disabled>
                                                                    <em>Select Days</em>
                                                                </MenuItem>

                                                                {(() => {
                                                                    let maxDays = 0;

                                                                    if (
                                                                        CheckPermissions(
                                                                            permissions,
                                                                            "Billing and Collection",
                                                                            "Due Date Extension",
                                                                            "Workflow Permissions",
                                                                            "3 Days"
                                                                        )
                                                                    ) {
                                                                        maxDays = 3;
                                                                    } else if (
                                                                        CheckPermissions(
                                                                            permissions,
                                                                            "Billing and Collection",
                                                                            "Due Date Extension",
                                                                            "Workflow Permissions",
                                                                            "5 Days"
                                                                        )
                                                                    ) {
                                                                        maxDays = 5;
                                                                    } else if (
                                                                        CheckPermissions(
                                                                            permissions,
                                                                            "Billing and Collection",
                                                                            "Due Date Extension",
                                                                            "Workflow Permissions",
                                                                            "8 Days"
                                                                        )
                                                                    ) {
                                                                        maxDays = 8;
                                                                    } else if (
                                                                        CheckPermissions(
                                                                            permissions,
                                                                            "Billing and Collection",
                                                                            "Due Date Extension",
                                                                            "Workflow Permissions",
                                                                            "10 Days"
                                                                        )
                                                                    ) {
                                                                        maxDays = 10;
                                                                    }

                                                                    return Array.from({ length: maxDays }, (_, i) => (
                                                                        <MenuItem key={i + 1} value={i + 1}>
                                                                            {i + 1}
                                                                        </MenuItem>
                                                                    ));
                                                                })()}
                                                            </Select>

                                                            {dueDateApprovalFormik.touched.iv_approved_no_of_days &&
                                                                dueDateApprovalFormik.errors.iv_approved_no_of_days && (
                                                                    <Typography
                                                                        variant="caption"
                                                                        color="error"
                                                                        sx={{ mt: 0.5, display: "block" }}
                                                                    >
                                                                        {dueDateApprovalFormik.errors.iv_approved_no_of_days}
                                                                    </Typography>
                                                                )}
                                                        </Grid>

                                                        {/* Extend Due Date*/}
                                                        <Grid item lg={6} md={4} sm={6} xs={12}>
                                                            <Typography className='label'>
                                                                Ext. Due Date
                                                            </Typography>
                                                            <TextField
                                                                value={dueDateApprovalFormik.values.iv_approved_due_date ? formatDateToShortMonth(dueDateApprovalFormik.values.iv_approved_due_date) : '-'}
                                                                fullWidth
                                                                size="small"
                                                                variant="outlined"
                                                                disabled
                                                                InputProps={{
                                                                    style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                }}
                                                            />
                                                        </Grid>

                                                        {/* Extend Due Date Day*/}
                                                        <Grid item lg={6} md={4} sm={6} xs={12}>
                                                            <Typography className='label'>
                                                                Ext. Due Date Day
                                                            </Typography>
                                                            <TextField
                                                                value={
                                                                    dueDateApprovalFormik.values.iv_approved_due_date
                                                                        ? getDayName(dueDateApprovalFormik.values.iv_approved_due_date)
                                                                        : "-"
                                                                }
                                                                fullWidth
                                                                size="small"
                                                                variant="outlined"
                                                                disabled
                                                                InputProps={{
                                                                    style: { height: "36px", backgroundColor: "#eef0f4" },
                                                                }}
                                                            />
                                                        </Grid>

                                                    </Grid>

                                                </Grid>
                                            </>
                                            :
                                            dialogRowData.applicationProgressId === 1 ?
                                                <>
                                                    <div className='step-title' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1%', padding: '0.5%' }}>
                                                        <h4 style={{ textAlign: 'center', width: '100%', marginTop: '0.5%' }} >Due Date Extended</h4>
                                                        <Button variant="outlined" onClick={() => { downloadBill(dialogRowData.refNo) }} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', width: '5%' }} ><DescriptionIcon sx={{ color: '#006ad1', marginLeft: '1%' }} /> Bill </Button>
                                                    </div>
                                                    <Grid container className='field-survey-container'>
                                                        <Grid item lg={12} sx={{ marginTop: '10px' }}>
                                                            <Grid container spacing={2} sx={{ mt: 2 }}>

                                                                {/* Customer ID */}
                                                                <Grid item lg={6} md={4} sm={6} xs={12}>
                                                                    <Typography className='label'>
                                                                        Current Due Date
                                                                    </Typography>
                                                                    <TextField
                                                                        value={dialogRowData.dueDate ? convertDate(dialogRowData.dueDate) : '-'}
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        disabled
                                                                        InputProps={{
                                                                            style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                {/* Bill Month */}
                                                                <Grid item lg={6} md={4} sm={6} xs={12}>
                                                                    <Typography className='label'>
                                                                        Requested Due Date
                                                                    </Typography>
                                                                    <TextField
                                                                        value={dialogRowData.appliedExtentionOfDueDate ? convertDate(dialogRowData.appliedExtentionOfDueDate) : '-'}
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        disabled
                                                                        InputProps={{
                                                                            style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                {/* No. of Days to Extend */}
                                                                <Grid item lg={6} md={4} sm={6} xs={12}>
                                                                    <Typography className='label'>
                                                                        No. of Days to Extend
                                                                    </Typography>

                                                                    <Select
                                                                        value={dueDateApprovalFormik.values.iv_approved_no_of_days}
                                                                        onChange={dueDateApprovalFormik.handleChange}
                                                                        name="iv_approved_no_of_days"
                                                                        displayEmpty
                                                                        fullWidth
                                                                        size="small"
                                                                        disabled
                                                                        sx={{
                                                                            '&.Mui-disabled': {
                                                                                backgroundColor: '#eef0f4 !important',
                                                                                borderRadius: '6px',
                                                                            },
                                                                            '& .MuiSelect-select': {
                                                                                backgroundColor: '#eef0f4 !important',
                                                                            },
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                borderColor: '#ccc',
                                                                            },
                                                                            height: '36px',
                                                                        }}
                                                                    >
                                                                        <MenuItem value="" disabled>
                                                                            <em>Select Days</em>
                                                                        </MenuItem>

                                                                        {(() => {
                                                                            let maxDays = 0;

                                                                            if (
                                                                                CheckPermissions(
                                                                                    permissions,
                                                                                    "Billing and Collection",
                                                                                    "Due Date Extension",
                                                                                    "Workflow Permissions",
                                                                                    "3 Days"
                                                                                )
                                                                            ) {
                                                                                maxDays = 3;
                                                                            } else if (
                                                                                CheckPermissions(
                                                                                    permissions,
                                                                                    "Billing and Collection",
                                                                                    "Due Date Extension",
                                                                                    "Workflow Permissions",
                                                                                    "5 Days"
                                                                                )
                                                                            ) {
                                                                                maxDays = 5;
                                                                            } else if (
                                                                                CheckPermissions(
                                                                                    permissions,
                                                                                    "Billing and Collection",
                                                                                    "Due Date Extension",
                                                                                    "Workflow Permissions",
                                                                                    "8 Days"
                                                                                )
                                                                            ) {
                                                                                maxDays = 8;
                                                                            } else if (
                                                                                CheckPermissions(
                                                                                    permissions,
                                                                                    "Billing and Collection",
                                                                                    "Due Date Extension",
                                                                                    "Workflow Permissions",
                                                                                    "10 Days"
                                                                                )
                                                                            ) {
                                                                                maxDays = 10;
                                                                            }

                                                                            return Array.from({ length: maxDays }, (_, i) => (
                                                                                <MenuItem key={i + 1} value={i + 1}>
                                                                                    {i + 1}
                                                                                </MenuItem>
                                                                            ));
                                                                        })()}
                                                                    </Select>

                                                                    {dueDateApprovalFormik.touched.iv_approved_no_of_days &&
                                                                        dueDateApprovalFormik.errors.iv_approved_no_of_days && (
                                                                            <Typography
                                                                                variant="caption"
                                                                                color="error"
                                                                                sx={{ mt: 0.5, display: "block" }}
                                                                            >
                                                                                {dueDateApprovalFormik.errors.iv_approved_no_of_days}
                                                                            </Typography>
                                                                        )}
                                                                </Grid>


                                                                {/* Extend Due Date*/}
                                                                <Grid item lg={6} md={4} sm={6} xs={12}>
                                                                    <Typography className='label'>
                                                                        Ext. Due Date
                                                                    </Typography>
                                                                    <TextField
                                                                        value={dialogRowData.approvedExtendedDueDate ? convertDate(dialogRowData.approvedExtendedDueDate) : '-'}
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        disabled
                                                                        InputProps={{
                                                                            style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                {/* Extend Due Date Day*/}
                                                                <Grid item lg={6} md={4} sm={6} xs={12}>
                                                                    <Typography className='label'>
                                                                        Ext. Due Date Day
                                                                    </Typography>
                                                                    <TextField
                                                                        value={
                                                                            dialogRowData.approvedExtendedDueDate
                                                                                ? getDayName(dialogRowData.approvedExtendedDueDate)
                                                                                : "-"
                                                                        }
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        disabled
                                                                        InputProps={{
                                                                            style: { height: "36px", backgroundColor: "#eef0f4" },
                                                                        }}
                                                                    />
                                                                </Grid>


                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                                :
                                                dialogRowData.applicationProgressId === -1 ?
                                                    <h3 className='step-title'>Request Declined</h3> :
                                                    <h3 className='step-title'>Testing Headline</h3>
                                    }
                                </div>
                                {/* <div className="actions">
                                    {dialogRowData.applicationProgressId === 0 && (

                                        <>
                                            {
                                                isReleventToUser ?
                                                    <>
                                                        {!isExtensionDateExpired(dialogRowData.appliedExtentionOfDueDate) &&
                                                            canApprove(parseInt(dialogRowData.currentBillAmount.replace(/,/g, ''))) && (
                                                                <button
                                                                    className="view-button"
                                                                    onClick={dueDateApprovalFormik.handleSubmit}
                                                                >
                                                                    Approve
                                                                </button>
                                                            )}

                                                        <button
                                                            className="reject-button"
                                                            style={{ float: "right", marginRight: "10px" }}
                                                            onClick={handleOpen}
                                                        >
                                                            Reject
                                                        </button>
                                                    </>
                                                    :
                                                    <div style={{ margin: 'auto', padding: '10px', backgroundColor: '#C46500', color: 'white', borderRadius: '5px', textAlign: 'center' }}>
                                                        <p style={{ fontSize: '20px' }}>
                                                            Application doesn't belongs to your office.
                                                        </p>
                                                    </div>
                                            }

                                        </>
                                    )}
                                </div> */}
                                <div className="actions">
                                    {isReleventToUser == true  ? (
                                        dialogRowData.applicationProgressId === 0 &&
                                            <>
                                                {!isExtensionDateExpired(dialogRowData.appliedExtentionOfDueDate) &&
                                                    canApprove(parseInt(dialogRowData.currentBillAmount.replace(/,/g, ''))) && (
                                                        <button
                                                            className="view-button"
                                                            onClick={dueDateApprovalFormik.handleSubmit}
                                                        >
                                                            Approve
                                                        </button>
                                                    )}

                                                <button
                                                    className="reject-button"
                                                    style={{ float: "right", marginRight: "10px" }}
                                                    onClick={handleOpen}
                                                >
                                                    Reject
                                                </button>
                                            </>
                                      
                                    ) : (
                                        <div
                                            style={{
                                                margin: 'auto',
                                                padding: '10px',
                                                backgroundColor: '#C46500',
                                                color: 'white',
                                                borderRadius: '5px',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <p style={{ fontSize: '20px' }}>
                                                Application doesn’t belong to your office.
                                            </p>
                                        </div>
                                    )}
                                </div>


                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog >

            < Dialog
                open={applicationSubittedPopUp}
                onClose={() => { setApplicationSubmittedPopUp(false) }}
                fullWidth={true}
                maxWidth={'md'}
                className='subpopup-dialog1' >
                <DialogTitle className='dialog-title'>
                    <p className='title'>
                        Application Submitted
                    </p>
                    <CloseIcon id="clearPopup" className='closeIcon' onClick={() => { setApplicationSubmittedPopUp(false) }} />
                </DialogTitle>
                <DialogContent className='dialog-content'>
                    <Grid container gap={1} className='container' >
                        <Grid item lg={12} className='application-details'>
                            <Grid item lg={3} className='first-row-item' >
                                <p className='prop-title'>Application Id</p>
                                <p className=' prop-detail'>{dialogRowData.applicationId}</p>
                            </Grid>
                            <Grid item lg={2} className='first-row-item' >
                                <p className='prop-title'>Applicant Name</p>
                                <p className=' prop-detail'>{dialogRowData.name}</p>
                            </Grid>
                            <Grid item lg={2} className='first-row-item' >
                                <p className='prop-title'>Received From</p>
                                <p className=' prop-detail'>{dialogRowData.cfcName ? dialogRowData.cfcName : '-'}</p>
                            </Grid>
                        </Grid>
                        <Grid item lg={12} className='application-details1'>
                            <Grid item lg={2} className='first-row-item' >
                                <p className='prop-title'>Applied Date</p>
                                <p className=' prop-detail'>{convertDate(dialogRowData.creationDate)}</p>
                            </Grid>
                            <Grid item lg={2} className='first-row-item' >
                                <p className='prop-title'>Subdivision</p>
                                <p className=' prop-detail'>{subdivisionName(dialogRowData.subDivisionCode, subDivisions)}</p>
                            </Grid>
                            <Grid item lg={2} className='first-row-item' >
                                <p className='prop-title'>Applied Load</p>
                                <p className=' prop-detail'>{dialogRowData.appliedLoad}</p>
                            </Grid>
                            <Grid item lg={2} className='first-row-item' >
                                <p className='prop-title'>Connection Type</p>
                                <p className=' prop-detail'>{dialogRowData.connectionType}</p>
                            </Grid>
                            <Grid item lg={2} className='first-row-item' >
                                <p className='prop-title'>Sub. Through</p>
                                <p className=' prop-detail'>{dialogRowData.submittedThrough}</p>
                            </Grid>

                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-action'>
                    <p className='description'>Application Submitted by:
                        {String(dialogRowData.createdBy).length === 13 && /^\d+$/.test(dialogRowData.createdBy)
                            ? dialogRowData.name
                            : dialogRowData.createdBy}
                        on: {convertDatewithTime(dialogRowData.creationDate)}</p>
                </DialogActions>
            </Dialog >

            < Dialog
                open={approvedPopup}
                onClose={() => { setApprovedPopup(false); handleClose(); }}
                className='dialog'
                fullWidth={true}
                maxWidth={'sm'}
                PaperProps={{ style: { width: '100%', borderRadius: 20 } }}
            >
                <DialogTitle  >
                    <Box className="backgroundAttached" >
                        <DoneIcon className="icon" />
                    </Box>
                    <Typography variant="h6" className="groupTitle"> Request Approved</Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <p className="applicationSubmit">  Due Date Extension request is Approved successfully.</p>
                        <p className="trackIdPara"><Button variant="outlined" onClick={() => { downloadBill(dialogRowData.refNo) }} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', width: '5%' }} ><DescriptionIcon sx={{ color: '#006ad1', marginLeft: '1%' }} /> Bill </Button></p>
                    </DialogContentText>
                </DialogContent>
            </Dialog >


            {/* Remarks Dialog */}
            <Dialog open={openCancelModal} className='objectionDialog' onClose={handleCloseRemarks} maxWidth="sm" fullWidth>
                <DialogTitle className="objection-dialog-title">
                    <Grid container className='objectionheadercontainer'>
                        <Grid item lg={11} className='applicationTitleGrid'>
                            <Typography className="applicationTitleText">Remarks</Typography>
                        </Grid>
                        <Grid item lg={1} className="closeIcon">
                            <CloseIcon id="clearPopup" onClick={handleCloseRemarks} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        placeholder="Enter Remarks"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={remarksFormik.handleChange}
                        onBlur={remarksFormik.handleBlur}
                        name="iv_remarks"
                        value={remarksFormik.values.iv_remarks}
                        multiline
                        rows={4}
                        InputLabelProps={{ shrink: false }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: 'rgba(173, 170, 170, 0.6)',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'rgba(173, 170, 170, 0.6)',
                                },
                            },
                        }}
                    />
                    {remarksFormik.touched.iv_remarks && remarksFormik.errors.iv_remarks && (
                        <p style={{ color: "#f73232", fontSize: "1rem" }}>
                            {remarksFormik.errors.iv_remarks}
                        </p>
                    )}
                    <Grid item lg={12} >
                        {
                            error &&
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        }
                    </Grid>
                    <DialogActions className="objection-dialog-action">
                        <Button onClick={remarksFormik.handleSubmit} type="submit" className='submit-button'>Confirm</Button>
                        <Button onClick={handleCloseRemarks} className='reject-button'>Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >

        </>
    )
})

export default DueDateExtensionTable;